import { render } from "./individual-stocks-raking.vue?vue&type=template&id=70de0098&scoped=true"
import script from "./individual-stocks-raking.vue?vue&type=script&lang=ts"
export * from "./individual-stocks-raking.vue?vue&type=script&lang=ts"

import "./individual-stocks-raking.vue?vue&type=style&index=0&id=70de0098&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70de0098"

export default script